var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar',{attrs:{"active":"churches"}}),_c('CrudNew',{attrs:{"tableName":"church","fields":_vm.fields,"titleRenderer":_vm.titleRenderer,"dataModifier":_vm.dataModifier}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }